<template lang="pug">
  shListData(title="Articles History" resolver="articlesHistory" keyData="_id" component="shArticle" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ArticlesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/article/ArticlesHistory.vue